import { HighlightsTextItem } from '@cmg/design-system';
import styled from 'styled-components';

export const StyledHighlightsTextItem = styled(HighlightsTextItem)`
  align-items: center !important;
`;
